import { getURL } from "./util";

var keycloak;
export class Auth {
  static get(url, headers) {
    let httpRequest = new XMLHttpRequest();
    if (!httpRequest) {
      alert("Giving up :( Cannot create an XMLHTTP instance");
      return false;
    }
    return new Promise((resolve, reject) => {
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            resolve(JSON.parse(httpRequest.responseText));
          } else {
            reject("error while making api")
          }
        }
      };
      httpRequest.open("GET", url);
      if (headers.length > 0) {
        headers.forEach((header) => {
          let key = Object.keys(header)[0];
          httpRequest.setRequestHeader(key, header[key]);
        });
      }
      httpRequest.send();
    });
  }

  static getCollegeDetails() {
    return new Promise((resolve, reject) => {
      let url = getURL(Auth.getAcademicLevel()).url + "/backgroundimageconfig/header/collegeinfo";
      let headers = [
        { Authorization: "Bearer  " + sessionStorage.getItem("token") },
      ];
      this.get(url, headers).then((college) => {
        if (college) {
          sessionStorage.setItem("college", JSON.stringify(college));
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  }
  static getTenantId() {
    if (this.getSelectedTenant()!=null) {
      return this.getSelectedTenant();
    }else
    if (this.getUser()) {
      return this.getUser().tenantId;
    } else {
      return getURL(Auth.getAcademicLevel()).college;
    }
  }

  static kcUser() {
    const tenantId = Auth.getTenantId();
    return new Promise((resolve, reject) => {

      let url = getURL(Auth.getAcademicLevel()).url + "/login/kcuser?college=" + tenantId;
      let headers = [
        { Authorization: "Bearer  " + sessionStorage.getItem("token") },
      ];
      this.get(url, headers).then((user) => {
        if (user) {
          sessionStorage.setItem("user", JSON.stringify(user));
          Auth.setSelectedTenantId(user.tenantId);
          Auth.setSelectedInstituteTenantId(user.tenantId);
          Auth.setSeletedTheme(user.theme);
          if (user.institutions && user.institutions.length > 0) {
            const currentInstitution = user.institutions?.
              find(institution => institution.currentInstitution);
            if (currentInstitution) {
              this.setCurrentHandlingInstitution(currentInstitution);
            } else {
              this.setCurrentHandlingInstitution(user.institutions[0]);
            }
          }
          
          if (
            this.getCurrentRole() == undefined ||
            this.getCurrentRole() == null
          ) {
            this.setCurrentRole(user.activeRole);
          }
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  }

  static init() {
    
  return new Promise((resolve, reject) => {
      const tenantId = Auth.getTenantId();

      let url = getURL(Auth.getAcademicLevel()).url + "/login/kc-init?college=" + tenantId;
      this.get(url, []).then((kc) => {
        if (kc) {
          keycloak = Keycloak({
            realm: kc.realm,
            url: kc["auth-server-url"],
            "ssl-required": kc["ssl-required"],
            clientId: kc["resource"],
            "verify-token-audience": true,
            "confidential-port": 0,
            "policy-enforcer": {},
          });
          keycloak
            .init({
              adapter: "default",
              flow: "standard",
              pkceMethod: "S256",
              onLoad: "login-required",
              checkLoginIframe: false,
            })
            .success((data) => {
              sessionStorage.setItem("token", keycloak.token);
              resolve(data);
            })
            .error(function () {
              reject(false);
            });
        }
      });
    });
  }

  static logout() {
    const tenantId = this.getUser().tenantId;
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("currentRole");
    sessionStorage.removeItem("college");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("fromPayment");
    sessionStorage.removeItem("mfrootLocation");
    keycloak.logout({ redirectUri: window.location.origin + "/" + tenantId });
  }

  static getCurrentRole() {
    try {
      const role = window.sessionStorage.getItem("roleSetDisplay");
      if (role != null && role != undefined) {
        sessionStorage.setItem("currentRole", role);
      }
      sessionStorage.removeItem("roleSetDisplay");
      return window.sessionStorage.getItem("currentRole");
    } catch (error) { }
  }

  static getUser() {
    try {
      return JSON.parse(window.sessionStorage.getItem("user"));
    } catch (error) { }
  }

  static getSelectedTenant() {
    try {
      return JSON.parse(window.sessionStorage.getItem("tenant-id"));
    } catch (error) { }
  }

  static getSelectedInstituteTenant() {
    try {
      return JSON.parse(window.sessionStorage.getItem("selected-tenant-id"));
    } catch (error) { }
  }


  static getToken() {
    try {
      return JSON.parse(window.sessionStorage.getItem("token"));
    } catch (error) { }
  }
  static getCollegeInfo() {
    try {
      return JSON.parse(window.sessionStorage.getItem("college"));
    } catch (error) { }
  }

  static setCurrentRole(currentRole) {
    try {
      var user = this.getUser();
      sessionStorage.setItem("currentRole", currentRole);
      user.activeRole = currentRole;
      sessionStorage.setItem("user", JSON.stringify(user));
    } catch (error) { }
  }

  static setCurrentHandlingDegreeDept(currentHandlingDegreeDept) {
    try {
      sessionStorage.setItem(
        "current-handling-degree-department",
        JSON.stringify(currentHandlingDegreeDept)
      );
    } catch (error) { }
  }

  static getCurrentHandlingDegreeDept() {
    try {
      return JSON.parse(
        window.sessionStorage.getItem("current-handling-degree-department")
      );
    } catch (error) { }
  }

  static removeCurrentHandlingDegreeDept() {
    try {
      sessionStorage.removeItem("current-handling-degree-department");
    } catch (error) { }
  }


  static setCollegeDetails(data) {
    try {
      sessionStorage.setItem("college", JSON.stringify(data));
    } catch (error) { }
  }


  static getAcademicLevel() {
    try {
      return JSON.parse(window.sessionStorage.getItem("academic-level"));
    } catch (error) {}
  }
  static getSourceAcademicLevel() {
    try {
      return JSON.parse(window.sessionStorage.getItem("source-academic-level"));
    } catch (error) { }
  }


  static setAcademicLevel(academicLevel) {
    try {
      return JSON.parse(window.sessionStorage.setItem("academic-level",JSON.stringify(academicLevel)));
    } catch (error) {}
  }


  static setSelectedAcademicLevel(academicLevel) {
    try {
      return JSON.parse(window.sessionStorage.setItem("selected-academic-level", JSON.stringify(academicLevel)));
    } catch (error) { }
  }

  static getSelectedAcademicLevel() {
    try {
      return JSON.parse(window.sessionStorage.getItem("selected-academic-level"));
    } catch (error) { }
  }

  static setSourceAcademicLevel(academicLevel) {
    try {
      return JSON.parse(window.sessionStorage.setItem("source-academic-level", JSON.stringify(academicLevel)));
    } catch (error) { }
  }

  static setSelectedTenantId(tenantId) {
    try {
      return JSON.parse(window.sessionStorage.setItem('tenant-id', tenantId));
    } catch (error) { }
  }


  static setSelectedInstituteTenantId(tenantId) {
    try {
      return JSON.parse(window.sessionStorage.setItem('selected-tenant-id',tenantId));
    } catch (error) { }
  }

  static setCurrentHandlingInstitution(institution) {
    try {
      if (!institution) {
        window.sessionStorage.removeItem("selected-institute");
      } else {
        window.sessionStorage.setItem("selected-institute", JSON.stringify(institution));
      }
    } catch (error) {
    }
  }

  static getCurrentHandlingInstitution() {
    try {
      return window.sessionStorage.getItem("selected-institute") ? JSON.parse(window.sessionStorage.getItem("selected-institute")) : undefined;
    } catch (error) { }
  }


 
static checkIfUniversity() {

  const tenantId = (Auth.getTenantId() || "").toLowerCase();

  const quickCheck =
    tenantId.includes("university") ||
    tenantId.includes("exam") ||
    tenantId.includes("examination");

  if (!quickCheck) {
    return Promise.resolve(false);
  }

  let url = getURL('UNIVERSITY').url + "/details/is-university";

  let headers = [{
    'tenant-id': tenantId
  }];

  return this.get(url, headers)
    .then((res) => {
      return !!res;
    })
    .catch(() => {
      return false;
    });
}
 
  static getMicroFrontendTypeToNavigate(){
    try {
      const microFrontendType = window.sessionStorage.getItem("microFrontendTypeForNavBar");
      if (microFrontendType != null && microFrontendType != undefined) {
        sessionStorage.setItem("microType", microFrontendType);
      }
      sessionStorage.removeItem("microFrontendTypeForNavBar");
      return window.sessionStorage.getItem("microType");
    } catch (error) { }
  }

  static getLocationNavigate(){
    try {
      return window.sessionStorage.getItem("mfrootLocation");
    } catch (error) { }
  }

  static setLocationNavigate(url){
    try {
      return window.sessionStorage.setItem("mfrootLocation",url);
    } catch (error) { }
  }
  static getNavigateUrl(){
    try {
      return window.sessionStorage.getItem("navigatedUrl");
    } catch (error) { }
  }
  
  static setNavigateUrl(url){
    try {
      if(url && url!="null"){
       window.sessionStorage.setItem("navigatedUrl",url);
      }
    } catch (error) { }
  }
  static setSelectedDepartment(selectedDepartment) {
    try {
      sessionStorage.setItem("selected-department", JSON.stringify(selectedDepartment));
    } catch (error) { }
  }

  static getSelectedDepartment() {
    try {
      return window.sessionStorage.getItem("selected-department") ? JSON.parse(window.sessionStorage.getItem("selected-department")) : undefined;
    } catch (error) { }
  }

  static setSeletedTheme(theme){
    try {
      var url = window.location.href.split("/")[2].split(".")[0];
      let defaultTheme=url === "klorofeel" || url === "hubpodschool" || url === "tdsb"?'klorofeel':'basic';
      document
      .getElementsByTagName('html')[0]
      .setAttribute('data-theme', theme?theme:defaultTheme);    
    } catch (error) {
    }
  }
}
